<div class="wrap">
  <div class="login-card">
    <div class="logo"><img [src]="appLogo" alt=""></div>
    <h1>Welcome</h1>

    <div class="practice" [class]="logoSize">
      <div class="practice-logo"><img [src]="loginLogo" alt=""></div>
    </div>

    <div class="login">
        <div class="title">Log in with</div>
      <ng-container *ngIf="loginServices.includes('vhd')">
        <div class="login-button">
          <p-button styleClass="p-button-vhd" [style]="{width: '100%'}" (click)="openLoginWindow('vhd')">
            <img src="/assets/images/vhd-logo-white.svg" class="vhd-button-icon" alt="">
          </p-button>
        </div>
      </ng-container>
      <ng-container *ngIf="loginServices.includes('rx-works')">
        <div class="login-button">
          <button pButton class="pm-button-primary" label="RxWorks" [style]="{width: '100%'}" (click)="openLoginWindow('rx')"></button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
